<template>
  <div id="property-list-skeleton">
    <div
      style="width:100%;"
    >
      <v-skeleton-loader
        class="loader"
        type="button"
      />
    </div>
    <div
      style="width:100%;"
      class="d-flex justify-space-between"
    >
      <v-skeleton-loader
        class="loader"
        width="40%"
        height="17px"
        type="button"
      />
      <v-skeleton-loader
        class="loader"
        width="40%"
        height="17px"
        type="button"
      />
    </div>
    <div
      style="width:100%;"
    >
      <v-skeleton-loader
        class="loader"
        type="button"
      />
    </div>
    <div
      style="width:100%;"
    >
      <v-skeleton-loader
        class="loader"
        type="button"
      />
    </div>
    <div
      class="mb-5"
      style="width:100%;"
    >
      <v-skeleton-loader
        class="loader"
        type="button"
      />
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PropertyListSkeleton',
  }
</script>
<style lang="scss">
#property-list-skeleton {
  .loader {
    width: 100%;
    margin-bottom: 13px;
    .v-skeleton-loader__button {
      width: 490px;
    }
  }
}
</style>
